import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiHelper } from "../../../utils/apiHelper";

export const fetchCampaignDetail = createAsyncThunk(
    "campaignDetail/fetch",
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get(`/startup/active/${startupId}`);
            if (response.data.code === "00000") {
                return response.data.startup;
            }
            throw new Error("Failed to fetch campaign details");
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const campaignDetailSlice = createSlice({
    name: "campaignDetail",
    initialState: {
        data: null,
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCampaignDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCampaignDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCampaignDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default campaignDetailSlice.reducer; 